import React, {useEffect} from "react"
import { connect } from "react-redux"
import BVASelect from "../../../../components/BVASelect/BVASelect";
import {
  fetchCompanyMonthlyBalanceSheet,
  generateCurrentCompanyBalanceSheetReport,
  updateBalanceSheetItem,
  updateMonthlyBalanceSheet
} from "../../../../store/modules/financials/actions";
import { updateCategory } from "../../../../store/modules/category/actions";
import FinancialAccount from "../../../../models/FinancialAccount";
import FinancialHandler from "../../../../handlers/FinancialHandler";
import {Divider} from "@mui/material";
import BalanceSheetRatiosConsolidation from "./MonthlyBalanceSheetConsolidation/BalanceSheetConsolidation";


function MonthlyBalanceSheetDashboard({
  companyData,
  dataSettings,
  currentCompanyMonthlyBalanceSheet,
  dispatchFetchBalanceSheetRatios,
  dispatchGenerateCurrentCompanyBalanceSheetReport,
  dispatchUpdateMonthlyBalanceSheet,
  dispatchUpdateBalanceSheetItem,
  dispatchUpdateCategory,
  dateOrder,
}) {
  // Mounted
  useEffect(() => {
    if (companyData && dataSettings) {
      handleFetchBalanceSheetRatios()
      dispatchGenerateCurrentCompanyBalanceSheetReport()
    }

    ////Initialize categories using GPT
    currentCompanyMonthlyBalanceSheet?.fixedAssetNames?.map((name) => 
      !currentCompanyMonthlyBalanceSheet?.getCategory({ name, groupName: "Fixed Assets", type: "assets" })
      && handleOnClickGPT({ name, groupName: "Fixed Assets", type: "assets" })
    )   //execute handleOnClickGPT if the category is undefined
    currentCompanyMonthlyBalanceSheet?.currentAssetNames?.map((name) =>
      !currentCompanyMonthlyBalanceSheet?.getCategory({ name, groupName: "Current Assets", type: "assets" })
      && handleOnClickGPT({ name, groupName: "Current Assets", type: "assets" })
    )
    currentCompanyMonthlyBalanceSheet?.currentLiabilityNames?.map((name) =>
      !currentCompanyMonthlyBalanceSheet?.getCategory({ name, groupName: "Current Liabilities", type: "liabilities" })
      && handleOnClickGPT({ name, groupName: "Current Liabilities", type: "liabilities" })
    )
    currentCompanyMonthlyBalanceSheet?.longTermLiabilityNames?.map((name) =>
      !currentCompanyMonthlyBalanceSheet?.getCategory({ name, groupName: "Long Term Liability", type: "liabilities" })
      && handleOnClickGPT({ name, groupName: "Long Term Liability", type: "liabilities" })
    )
    currentCompanyMonthlyBalanceSheet?.equityNames?.map((name) =>
      !currentCompanyMonthlyBalanceSheet?.getCategory({ name, type: "equity" })
      && handleOnClickGPT({ name, type: "equity" })
    )
  }, [])

  // Methods
  const handleFetchBalanceSheetRatios = async () => {
    await dispatchFetchBalanceSheetRatios({ companyId: companyData?.companyId }, {
      periodsToCompare: dataSettings?.yearsToFetch
    }, { dateOrder })
  }

  const handleCategoryOnChange = ({ name, type, groupName }, { category }) => {
    dispatchUpdateCategory(name, category);
    dispatchUpdateMonthlyBalanceSheet({ name, type, groupName }, { category });
    dispatchUpdateBalanceSheetItem({ name, type }, { category });
  }

  const handleOnClickGPT = async ({ name, type, groupName }) => {
    const category = await FinancialHandler.fetchGPTCategorySelection(name, groupName || "Equity");
    handleCategoryOnChange({ name, type, groupName }, { category })
  }

  // const handleTestOnClick = async () => {
  //   const result = await FinancialHandler.fetchCompanyBalanceSheet(
  //     { companyId: "test" },
  //     {
  //       sourceType: "QBO",
  //       startMonth: "2024-01-01",
  //       endMonth: "2024-02-01",
  //     }
  //   );
  //   console.log(result)
  // }

  return (
    <div>
      <div className="overflow-auto">
        <div className="flex items-center w-full">
          <div style={{ minWidth: "26em" }}></div>
          <div style={{ minWidth: "14em" }}>
            <label className="font-semibold">Category</label>
          </div>
          {currentCompanyMonthlyBalanceSheet?.datesFormatted?.map((date) => (
            <div className="w-40 font-semibold" style={{ minWidth: "10em" }}>
              <label>{date}</label>
            </div>
          ))}
        </div>
        <div className="mt-5">
          <div className="mb-10">
            <label className="font-semibold">Fixed Assets</label>
            <div className="mt-5">
              {currentCompanyMonthlyBalanceSheet?.fixedAssetNames?.map((name, balanceSheetAssetItemIndex) => (
                <div key={balanceSheetAssetItemIndex} className="flex items-center mb-2">
                  <div className="whitespace-pre-wrap flex items-center" style={{ minWidth: "17em" }}>
                    <label>{name}</label>
                  </div>
                  <button
                    style={{ minWidth: "3em" }}
                    onClick={() => handleOnClickGPT({ name, groupName: "Fixed Assets", type: "assets" })}
                  >
                    🤖
                  </button>
                  <div className="flex items-center" style={{ minWidth: "20em" }}>
                    <BVASelect
                      items={FinancialAccount.getAssetsCategoryOptions().filter((category) => category.group === "Fixed Assets")}
                      itemLabel="name"
                      width="14em"
                      placeholder="Select a category"
                      value={currentCompanyMonthlyBalanceSheet?.getCategory({ name, groupName: "Fixed Assets", type: "assets" })}
                      onChange={(category) => handleCategoryOnChange({ name, groupName: "Fixed Assets", type: "assets" }, { category })}
                    />
                  </div>
                  {currentCompanyMonthlyBalanceSheet?.getFixedAssetsByName(name)?.map((fixedAsset) => (
                    <div className="flex items-center" style={{ minWidth: "10em" }}>
                      <label>{fixedAsset?.formattedValue}</label>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="mb-10">
            <label className="font-semibold">Current Assets</label>
            <div className="mt-5">
              {currentCompanyMonthlyBalanceSheet?.currentAssetNames?.map((name, balanceSheetAssetItemIndex) => (
                <div key={balanceSheetAssetItemIndex} className="flex items-center mb-2">
                  <div className="whitespace-pre-wrap flex items-center" style={{ minWidth: "17em" }}>
                    <label>{name}</label>
                  </div>
                  <button
                    style={{ minWidth: "3em" }}
                    onClick={() => handleOnClickGPT({ name, groupName: "Current Assets", type: "assets" })}
                  >
                    🤖
                  </button>
                  <div className="flex items-center" style={{ minWidth: "20em" }}>
                    <BVASelect
                      items={FinancialAccount.getAssetsCategoryOptions().filter((category) => category.group === "Current Assets")}
                      itemLabel="name"
                      width="14em"
                      placeholder="Select a category"
                      value={currentCompanyMonthlyBalanceSheet?.getCategory({ name, groupName: "Current Assets", type: "assets" })}
                      onChange={(category) => handleCategoryOnChange({ name, groupName: "Current Assets", type: "assets" }, { category })}
                    />
                  </div>
                  {currentCompanyMonthlyBalanceSheet?.getCurrentAssetsByName(name)?.map((currentAsset) => (
                    <div className="flex items-center" style={{ minWidth: "10em" }}>
                      <label>{currentAsset?.formattedValue}</label>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="mb-10">
            <label className="font-semibold">Current Liabilities</label>
            <div className="mt-5">
              {currentCompanyMonthlyBalanceSheet?.currentLiabilityNames?.map((name, balanceSheetLiabilityItemIndex) => (
                <div key={balanceSheetLiabilityItemIndex} className="flex items-center mb-2">
                  <div className="whitespace-pre-wrap flex items-center" style={{ minWidth: "17em" }}>
                    <label>{name}</label>
                  </div>
                  <button
                    style={{ minWidth: "3em" }}
                    onClick={() => handleOnClickGPT({ name, groupName: "Current Liabilities", type: "liabilities" })}
                  >
                    🤖
                  </button>
                  <div className="flex items-center" style={{ minWidth: "20em" }}>
                    <BVASelect
                      items={FinancialAccount.getLiabilitiesCategoryOptions().filter((category) => category.group === "Current Liabilities")}
                      itemLabel="name"
                      width="14em"
                      placeholder="Select a category"
                      value={currentCompanyMonthlyBalanceSheet?.getCategory({ name, groupName: "Current Liabilities", type: "liabilities" })}
                      onChange={(category) => handleCategoryOnChange({ name, groupName: "Current Liabilities", type: "liabilities" }, { category })}
                    />
                  </div>
                  {currentCompanyMonthlyBalanceSheet?.getCurrentLiabilities(name)?.map((fixedAsset) => (
                    <div className="flex items-center" style={{ minWidth: "10em" }}>
                      <label>{fixedAsset?.formattedValue}</label>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="mb-10">
            <label className="font-semibold">Long Term Liabilities</label>
            <div className="mt-5">
              {currentCompanyMonthlyBalanceSheet?.longTermLiabilityNames?.map((name, balanceSheetLiabilityItemIndex) => (
                <div key={balanceSheetLiabilityItemIndex} className="flex items-center mb-2">
                  <div className="whitespace-pre-wrap flex items-center" style={{ minWidth: "17em" }}>
                    <label>{name}</label>
                  </div>
                  <button
                    style={{ minWidth: "3em" }}
                    onClick={() => handleOnClickGPT({ name, groupName: "Long Term Liability", type: "liabilities" })}
                  >
                    🤖
                  </button>
                  <div className="flex items-center" style={{ minWidth: "20em" }}>
                    <BVASelect
                      items={FinancialAccount.getLiabilitiesCategoryOptions().filter((category) => category.group === "Long Term Liability")}
                      itemLabel="name"
                      width="14em"
                      placeholder="Select a category"
                      value={currentCompanyMonthlyBalanceSheet?.getCategory({ name, groupName: "Long Term Liability", type: "liabilities" })}
                      onChange={(category) => handleCategoryOnChange({ name, groupName: "Long Term Liability", type: "liabilities" }, { category })}
                    />
                  </div>
                  {currentCompanyMonthlyBalanceSheet?.getLongTermLiabilities(name)?.map((fixedAsset) => (
                    <div className="flex items-center" style={{ minWidth: "10em" }}>
                      <label>{fixedAsset?.formattedValue}</label>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="mb-10">
            <label className="font-semibold">Equity</label>
            <div className="mt-5">
              {currentCompanyMonthlyBalanceSheet?.equityNames?.map((name, balanceSheetLiabilityItemIndex) => (
                <div key={balanceSheetLiabilityItemIndex} className="flex items-center mb-2">
                  <div className="whitespace-pre-wrap flex items-center" style={{ minWidth: "17em" }}>
                    <label>{name}</label>
                  </div>
                  <button
                    style={{ minWidth: "3em" }}
                    onClick={() => handleOnClickGPT({ name, type: "equity" })}
                  >
                    🤖
                  </button>
                  <div className="flex items-center" style={{ minWidth: "20em" }}>
                    <BVASelect
                      items={FinancialAccount.getEquitiesCategoryOptions()}
                      itemLabel="name"
                      width="14em"
                      placeholder="Select a category"
                      value={currentCompanyMonthlyBalanceSheet?.getCategory({ name, type: "equity" })}
                      onChange={(category) => handleCategoryOnChange({ name, type: "equity" }, { category })}
                    />
                  </div>
                  {currentCompanyMonthlyBalanceSheet?.getEquityItems(name)?.map((fixedAsset) => (
                    <div className="flex items-center" style={{ minWidth: "10em" }}>
                      <label>{fixedAsset?.formattedValue}</label>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="py-10">
        <Divider />
      </div>
      <div className="overflow-auto">
        <BalanceSheetRatiosConsolidation />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  companyData: state.appState.companyData,
  dataSettings: state.appState.dataSettings,
  currentCompanyMonthlyBalanceSheet: state.financials.currentCompanyMonthlyBalanceSheet,
})

const mapDispatchToProps = (dispatch) => ({
  async dispatchFetchBalanceSheetRatios({ companyId }, { periodsToCompare }, { dateOrder }) {
    await dispatch(fetchCompanyMonthlyBalanceSheet({ companyId }, { periodsToCompare }, { dateOrder }))
  },

  async dispatchGenerateCurrentCompanyBalanceSheetReport() {
    await dispatch(generateCurrentCompanyBalanceSheetReport())
  },
  
  dispatchUpdateMonthlyBalanceSheet({ name, type, groupName }, { category }) {
    dispatch(updateMonthlyBalanceSheet({ name, type, groupName }, { category }))
  },

  dispatchUpdateBalanceSheetItem({ name, type }, { category }) {
    dispatch(updateBalanceSheetItem({ name, type }, { category }))
  },

  dispatchUpdateCategory(name, category) {
    dispatch(updateCategory(name, category))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyBalanceSheetDashboard)
